import { TCurrencyExchange } from '../modules/TokenizedApiModelEntities';

function findExchangeRate(
  rates: TCurrencyExchange[],
  from: string,
  to: string,
): number | null {
  if (from == to) return 1;

  const nextStepRates = rates.filter((ex) => ex.to != from);

  for (const exchange of rates.filter((ex) => ex.from == from)) {
    const foundRate = findExchangeRate(nextStepRates, exchange.to, to);

    if (foundRate) {
      return exchange.rate * foundRate;
    }
  }

  return null;
}

export default class ExchangeRates {
  /** @internal */
  exchangeRates: TCurrencyExchange[];

  /** @internal */
  constructor(exchangeRates: TCurrencyExchange[]) {
    this.exchangeRates = [
      ...exchangeRates,
      ...exchangeRates.map(({ from, to, rate }) => ({
        from: to,
        to: from,
        rate: 1 / rate,
      })),
    ];
  }

  findRate(
    from: string | null | undefined,
    to: string | null | undefined,
  ): number | null {
    if (!from || !to) return null;

    return findExchangeRate(this.exchangeRates, from, to);
  }
}
